document.addEventListener("DOMContentLoaded", () => {

  const video = document.querySelector("video.plyr_video_el");

  if (!video) {
    console.warn("No video element found with class 'plyr_video_el'.");
    return;
  }

  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }

  const body = document.body;
  const sources = document.querySelectorAll("video.plyr_video_el source");
  const fullscreenCloseButton = document.querySelector(".plyr-fullscreen-close");
  const useHls = video.getAttribute("data-hls");
  const useNativeIOS = video.getAttribute("data-ios-native") === "true";
  const isIOSDevice = isIOS();
  const videoMuted = video.hasAttribute("muted");
  const videoLooped = video.hasAttribute("loop");
  const wallpaperMode = video.getAttribute("data-wallpaper-mode") === "true";
  console.log("muted: ", videoMuted);
  //const useNativeIOS = false;
  console.log("usenativeIOS: ", useNativeIOS);
  //const playButton = document.querySelector(".plyr-play-button");

  if(isIOSDevice && !useNativeIOS) {
    window.addEventListener('orientationchange', () => {
      const y = window.scrollY;

      setTimeout(() => window.scrollTo(0, y), 250);
      setTimeout(() => window.scrollTo(0, y), 600); // Repeat just in case
    });
  }

  function fixPlyrFullscreenBug() {
    setTimeout(() => {
      window.scrollBy(0, 1);
      window.scrollBy(0, -1);
    }, 100);
  }

  function bindFullscreenEvents(player) {
    player.on('enterfullscreen', () => {
      body.classList.add('body--plyr--fullscreen-enabled');
    });
    player.on('exitfullscreen', () => {
      body.classList.remove('body--plyr--fullscreen-enabled');
    });
  }

  /*function bindEndedEvents(player) {
    player.on('ended', () => {
      //player.pause();
      player.currentTime = 0;
      
      if (player.fullscreen.active) {
        player.fullscreen.exit();
      }
    });
  }*/

  function setupBufferingSpinner(player, hls) {
    console.log("player: ", player.elements.container.parentElement);
    const spinner = player.elements.container.parentElement.querySelector('.loading__spinner');

    const showSpinner = () => spinner.classList.remove('hidden');
    const hideSpinner = () => spinner.classList.add('hidden');

    // Plyr buffering events
    player.on('ready', hideSpinner);
    player.on('waiting', showSpinner); // when buffering starts
    player.on('playing', hideSpinner); // when playback resumes

    // Fallback for pause/resume
    player.on('pause', hideSpinner);
    player.on('ended', hideSpinner);

    // HLS.js events (optional for more control)
    if (hls) {
      hls.on(Hls.Events.BUFFER_STALLED, showSpinner);
      hls.on(Hls.Events.BUFFER_APPENDED, hideSpinner);
      hls.on(Hls.Events.FRAG_LOADED, hideSpinner);
      hls.on(Hls.Events.ERROR, hideSpinner); // hide on error to avoid spinner hang
    }
  }


  function hardResetVideo(player, hls, sourceUrl) {
    console.log("Performing hard reset of video...");
    video.autoplay = false;
    player.pause();
    hls.detachMedia();
    hls.loadSource(sourceUrl);
    hls.attachMedia(player.media);
    player.currentTime = 0;
    player.poster = player.config.poster;
  }

  function bindEndedEvents(player) {
    player.on('ended', () => {
      player.pause();
      player.currentTime = 0;

      // Force UI to re-render poster image immediately
      /*setTimeout(() => {
        player.elements.container.classList.remove('plyr--playing');
      }, 0);*/
    });
  }

  function enableInline(player){
    if ('playsInline' in video) {
      video.setAttribute('playsinline', '');
    }
  }

  function muteVideo(player) {
    player.muted = true;
  }

  function minimalScrollThenFullscreen(player) {
    const originalScrollY = window.scrollY;

    // Scroll down by 1px
    window.scrollTo(0, originalScrollY + 1);

    // Then scroll back after fullscreen (optional)
    setTimeout(() => {
      if (!player.fullscreen.active) {
        player.fullscreen.enter();
      }

      // Optionally restore scroll position
      setTimeout(() => {
        window.scrollTo(0, originalScrollY);
      }, 500);
    }, 100);
  }


  function forceTouchScreenFullscreen(player) {
    player.on('play', () => {
      const isTouch = player.elements.container.classList.contains('plyr--is-touch');
      if (isTouch && (!isIOSDevice  || (isIOSDevice && !useNativeIOS))) {
        player.fullscreen.enter();
        //player.webkitRequestFullscreen();
      }
    });
  }

  function pauseOnExitFullscreen(player) {
    player.on('exitfullscreen', () => {
      if (player.playing) {
        player.pause();
      }
    });
  }

  function fullscreenClose(player) {
    fullscreenCloseButton.addEventListener('click', () => {
      if (player.fullscreen.active) {
        player.fullscreen.exit();
      }
    });

    player.on('enterfullscreen', () => {
      fullscreenCloseButton.classList.add('visible');
    });
    
    player.on('exitfullscreen', () => {
      fullscreenCloseButton.classList.remove('visible');
    });
  }

  function inlineOverlaidPlayIcon(player) {
    const btn = player.elements.container.querySelector('.plyr__control--overlaid');
    if (!btn) return;

    // Replace the big overlay button contents with an inline SVG
    btn.innerHTML = `
      <svg id="play-button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><polygon id="play-button-outer" points="77.87 21.64 77.87 77.87 2.12 77.87 2.12 2.12 58.25 2.12 58.25 0 0 0 0 80 79.99 80 79.99 21.64 77.87 21.64" fill="#fff" stroke-width="0"/><path id="play-button-inner" d="M23.9,62.52l39.01-22.52h0L23.9,17.48v45.04ZM26.5,21.99l31.19,18.01-31.19,18.01V21.99Z" fill="#fff" stroke-width="0"/></svg>
    `;
  }


  // For more options see: https://github.com/sampotts/plyr/#options
  // captions.update is required for captions to work with hls.js
  const defaultOptions = {
    poster: video.getAttribute("data-poster") || "",
    controls: [
      'play-large',
      'play',
      'progress',
      'mute',
      'volume',
      //'settings',
      'fullscreen'
    ],
    fullscreen: {
      enabled: true,
      fallback: true,
      iosNative: useNativeIOS
    },
    resetOnEnd: false,
    storage: { enabled: false },
    //loadSprite: false,
    //ratio: null
  };

  if (isIOSDevice && useNativeIOS) {
    defaultOptions.controls = [
      'play-large',
      'play',
      'progress',
      'mute',
      'volume',
      //'settings',
      //'fullscreen'
    ];
  }

  if(wallpaperMode == true) {
    defaultOptions.controls = [];
    defaultOptions.fullscreen = {
      enabled: false
    }
    defaultOptions.clickToPlay = false;
    defaultOptions.hideControls = true;
  }

  if (Hls.isSupported() && useHls === "true" && (!isIOSDevice || isIOSDevice && !useNativeIOS)) {
    console.log("Hls.js is supported, initializing...");
    // For more Hls.js options, see https://github.com/dailymotion/hls.js

    const hls = new Hls();
    window.hls = hls;

    const source = sources[0].src;
    hls.loadSource(source);

    hls.autoLevelEnabled = true;

    hls.on(Hls.Events.LEVEL_SWITCHED, function(event, data) {
      const level = hls.levels[data.level];
      console.log(`Now playing: ${level.height}p`);
    });

    // From the m3u8 playlist, hls parses the manifest and returns
    // all available video qualities. This is important, in this approach,
    // we will have one source on the Plyr player.
    hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {

      // Transform available levels into an array of integers (height values).
      const availableQualities = hls.levels.map((l) => l.height);
      console.log("Available qualities: ", availableQualities);

      const maxHeight = Math.max(...availableQualities);
      const maxIndex = hls.levels.findIndex(level => level.height === maxHeight);

      // Start playback at the highest level; ABR can still downshift if needed.
      if (maxIndex !== -1) {
        hls.startLevel = maxIndex;
        hls.currentLevel = maxIndex;
        console.log(`Startup: set initial quality to ${maxHeight}p`);
      }

      // Add new qualities to option
      defaultOptions.quality = {
        default: availableQualities[1],
        //default: 0,
        options: availableQualities,
        // this ensures Plyr to use Hls to update quality level
        forced: true,
        onChange: (e) => updateQuality(e),
        //mute: muteVideo
      }
      console.log("PLYR OPTIONS:", defaultOptions);
      const player = new Plyr(video, defaultOptions);
      
      inlineOverlaidPlayIcon(player);

      if(videoMuted == true) {
        muteVideo(player);
      }

      player.on('enterfullscreen', () => {
        console.log("Entering fullscreen mode...");
        //enableTouchBlock();
        //window.addEventListener('orientationchange', fixPlyrFullscreenBug);
        const maxHeight = Math.max(...availableQualities);
        const maxIndex = hls.levels.findIndex(level => level.height === maxHeight);

        if (maxIndex !== -1) {
          hls.currentLevel = maxIndex;
          console.log(`Fullscreen: switched to ${maxHeight}p`);
        }
      });

      player.on('exitfullscreen', () => {
        console.log("Exiting fullscreen mode...");
        //disableTouchBlock();
        //window.removeEventListener('orientationchange', fixPlyrFullscreenBug);
        const defaultHeight = defaultOptions.quality.default;
        const defaultIndex = hls.levels.findIndex(level => level.height === defaultHeight);
        
        if (defaultIndex !== -1) {
          hls.currentLevel = defaultIndex;
          console.log(`Exited fullscreen: reverted to ${defaultHeight}p`);
        }
      });

      function updateQuality(newQuality) {
        window.hls.levels.forEach((level, levelIndex) => {
          if (level.height === newQuality) {
            console.log("Found quality match with " + newQuality);
            window.hls.currentLevel = levelIndex;
          }
        });
      }

      //bindFullscreenEvents(player);
      forceTouchScreenFullscreen(player);
      enableInline(player);
      pauseOnExitFullscreen(player);
      fullscreenClose(player);
      //bindEndedEvents(player);

      if(videoLooped != true) {
        player.on('ended', () => {
          console.log("Video ended, resetting...");
          hardResetVideo(player, hls, source);
        });
      }

      setupBufferingSpinner(player, true);

      /*player.on('playing', function(){
        player.muted = false;

      });*/
    });
    
    hls.attachMedia(video);
    //window.hls = hls;
  } else {
    const source = sources[1].src;
    console.warn("Hls.js is not supported or not enabled. Using fallback source: " + source);
    // default options with no quality update in case Hls is not supported
    const player = new Plyr(video, defaultOptions);
    inlineOverlaidPlayIcon(player);

    //bindFullscreenEvents(player);
    if(!isIOSDevice || (isIOSDevice && !useNativeIOS)) {
      forceTouchScreenFullscreen(player);
      enableInline(player);
    }

    if(videoMuted == true) {
      muteVideo(player);
    }

    bindEndedEvents(player);
    pauseOnExitFullscreen(player);
    fullscreenClose(player);

    setupBufferingSpinner(player, false);
  }
});
